// src/components/Pages/Videos.jsx  →  /videos
import React from 'react';
import { Link } from 'react-router-dom';
import { FiVideo, FiPlay, FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { useAuthGate } from '../../Context/AuthGateContext';
import './InfoPages.css';

const TUTORIALS = [
  { title: 'Tu primer trade P2P', meta: 'Cómo comprar paso a paso' },
  { title: 'Cómo funciona el escrow', meta: 'Seguridad en cada operación' },
  { title: 'Armá tu portafolio', meta: 'Seguí tus inversiones en vivo' },
  { title: 'Verificación por niveles', meta: 'Subí de nivel tu cuenta' },
  { title: 'Crear una oferta', meta: 'Para vendedores verificados' },
  { title: 'Gana XP y recompensas', meta: 'El lado gamer de Bitplify' },
];

export default function Videos() {
  const { openAuth } = useAuthGate();
  return (
    <div className="ip-wrap">
      <Link to="/" className="ip-back"><FiArrowLeft /> Volver al marketplace</Link>

      <div className="ip-hero">
        <span className="ip-eyebrow"><FiVideo /> Videos tutoriales</span>
        <h1 className="ip-title">Aprendé a operar en minutos</h1>
        <p className="ip-sub">Estamos produciendo la videoteca. Estos son los tutoriales que llegan en las próximas fases.</p>
        <span className="ip-phase-badge"><span className="ip-live-dot" /> Próximamente · fase MVP</span>
      </div>

      <section className="ip-section">
        <div className="ip-video-grid">
          {TUTORIALS.map((t, i) => (
            <div key={i} className="ip-video-card">
              <div className="ip-video-thumb">
                <FiPlay />
                <span className="ip-video-soon">Pronto</span>
              </div>
              <div className="ip-video-body">
                <h3 className="ip-video-title">{t.title}</h3>
                <span className="ip-video-meta">{t.meta}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="ip-cta">
        <h3>Mientras tanto, probalo vos mismo</h3>
        <p>La mejor forma de aprender es operando. Creá tu cuenta gratis.</p>
        <button className="ip-cta-btn" onClick={() => openAuth('register')}>Crear mi cuenta <FiArrowRight /></button>
      </div>
    </div>
  );
}
